// ============================================
// ADA FIX: Keyboard focus ring detection
//
// Adds 'user-is-tabbing' class to body when
// keyboard navigation is detected. Mouse users
// never see focus rings.
// ============================================
(function () {
  function handleFirstTab(e) {
    if (e.key === 'Tab') {
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
      window.addEventListener('mousedown', handleMouseDown);
    }
  }
  function handleMouseDown(e) {
    // ⚠️ FIX: Ignore mousedown on summary/details elements.
    // Empire theme uses <details><summary> for nav dropdowns.
    // Opening them fires a synthetic mousedown which incorrectly
    // removes user-is-tabbing during keyboard navigation.
    var target = e.target;
    if (
      target.tagName === 'SUMMARY' ||
      target.closest('summary') ||
      target.closest('details') ||
      target.closest('.navmenu-link-parent') ||
      target.closest('.site-nav') ||
      target.closest('nav')
    ) {
      return;
    }
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDown);
    window.addEventListener('keydown', handleFirstTab);
  }
  window.addEventListener('keydown', handleFirstTab);
})();


// ============================================
// ADA FIX: Focus ring styles
//
// Appended to document.body so it lands AFTER
// all theme stylesheets. Gated on
// body.user-is-tabbing so mouse users never
// see focus rings.
// ============================================
function injectFocusStyles() {
  var existingStyle = document.getElementById('ada-focus-fix');
  if (existingStyle) existingStyle.parentNode.removeChild(existingStyle);

  var style = document.createElement('style');
  style.id = 'ada-focus-fix';
  style.innerHTML = [

    // ---- General focus ring for all interactive elements ----
    'body.user-is-tabbing a:focus,',
    'body.user-is-tabbing button:focus,',
    'body.user-is-tabbing input:focus,',
    'body.user-is-tabbing select:focus,',
    'body.user-is-tabbing textarea:focus,',
    'body.user-is-tabbing [tabindex]:focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 3px !important;',
    '}',

    // ---- PageFly elements — explicit override to ensure focus ring shows ----
    'body.user-is-tabbing .__pf a:focus,',
    'body.user-is-tabbing .__pf button:focus,',
    'body.user-is-tabbing .__pf input:focus,',
    'body.user-is-tabbing .__pf select:focus,',
    'body.user-is-tabbing .__pf textarea:focus,',
    'body.user-is-tabbing .__pf [tabindex]:focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 3px !important;',
    '}',

    // ---- Product detail page price focus ring ----
    // When the hidden summary element is focused, rings appear on
    // the visible h1 title and price block instead.
    'body.user-is-tabbing h1.ada-detail-focused,',
    'body.user-is-tabbing .product-block--price.ada-detail-focused {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 6px !important;',
    '  border-radius: 8px !important;',
    '}',
    // Keep the hidden summary element invisible always
    '#ada-product-summary:focus {',
    '  outline: none !important;',
    '}',

    // ---- Product card focus ring ----
    // When the title link is focused, draw a ring around the entire
    // product card (image + badge + price + title) so keyboard users
    // can see exactly what product is in focus.
    'body.user-is-tabbing .productgrid--item.ada-card-focused {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 6px !important;',
    '  border-radius: 8px !important;',
    '}',

    // Suppress the default focus ring on the title link itself
    // since the whole-card ring above already shows focus clearly
    'body.user-is-tabbing p.productitem--title a:focus {',
    '  outline: none !important;',
    '}',

    // ---- PageFly circular image links ----
    // Image + label are merged into one <a> by fixPageFlyImageLinks().
    // Rounded rectangle ring hugs both the image and the text label.
    'body.user-is-tabbing a:has(img.pf-image-1):focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 6px !important;',
    '  border-radius: 12px !important;',
    '  display: block !important;',
    '}',

    // ---- Empire product card image links ----
    // Empire wraps product images in <a> tags. outline on a block <a>
    // wrapping an <img> is often invisible because the image fills the
    // entire box. box-shadow on the img renders ON TOP — always visible.
    'body.user-is-tabbing .grid-item a:focus img,',
    'body.user-is-tabbing .product-item a:focus img,',
    'body.user-is-tabbing .grid__item a:focus img,',
    'body.user-is-tabbing .featured-collection a:focus img,',
    'body.user-is-tabbing .product-card a:focus img,',
    'body.user-is-tabbing a:focus img {',
    '  box-shadow: 0 0 0 3px #fff, 0 0 0 6px #3b82f6 !important;',
    '}',

    // ---- Summary/Details nav dropdowns (Empire theme) ----
    'body.user-is-tabbing summary:focus,',
    'body.user-is-tabbing summary.navmenu-link:focus,',
    'body.user-is-tabbing .navmenu-link-parent:focus {',
    '  outline: 3px solid #3b82f6 !important;',
    '  outline-offset: 3px !important;',
    '}',

    // ---- CBB shipping layout ----
    '.cbb-shipping-rates-calculator-shipping-address-chooser { overflow: visible !important; }',

    // ---- Contrast fixes ----
    '.back-to-top__button-label { color: #1a1a1a !important; }',
    '.site-footer-credits { color: #4a4a4a !important; }',

    // ---- Touch targets ----
    'a.announcement-bar-link { min-height: 44px !important; display: inline-flex !important; align-items: center !important; }',

  ].join('\n');

  document.body.appendChild(style);
}


// ============================================
// ADA FIX: PageFly circular image links
//
// PageFly renders category images as <img> tags
// with data-href attributes, and the text label
// below is a separate <h3> with its own <a>.
// This means keyboard users get TWO tab stops
// per item (one ring on the image, one rectangle
// on the text) which is redundant and confusing.
//
// This fix merges both into ONE <a> that wraps
// the image and the h3 together — one tab stop,
// one focus ring, one clean aria-label.
//
// Also cleans up keyword-stuffed alt text like

// screen readers get a clean label instead.
// ============================================
function fixPageFlyImageLinks() {
  document.querySelectorAll('img.pf-image-1[data-href]').forEach(function (img) {
    if (img.dataset.adaImageFixed === 'true') return;
    img.dataset.adaImageFixed = 'true';

    // Skip if already inside an <a> tag — PageFly already wrapped it
    if (img.closest('a')) return;

    var href   = img.getAttribute('data-href');
    var target = img.getAttribute('data-target') || '_self';

    // Clean keyword-stuffed alt text down to just the product name
    var rawAlt = img.getAttribute('alt') || '';
    var label  = rawAlt.split(' near me')[0].split(' |')[0].trim() || 'View collection';

    // Image is decorative — the <a> aria-label carries the name
    img.setAttribute('alt', '');
    img.setAttribute('aria-hidden', 'true');

    // Find the sibling h3 label inside the same column wrapper
    var column = img.closest('.pf-c');
    var h3     = column && column.querySelector('h3');

    // Build the single wrapper <a>
    var a = document.createElement('a');
    a.href   = href;
    a.target = target;
    a.setAttribute('aria-label', label);
    a.style.display        = 'flex';
    a.style.flexDirection  = 'column';
    a.style.alignItems     = 'center';
    a.style.textDecoration = 'none';

    // Insert <a> before the image, then move image inside it
    img.parentNode.insertBefore(a, img);
    a.appendChild(img);

    // Move h3 inside the same <a>, replacing any inner <a> with a <span>
    // to avoid illegal nested <a><a> markup
    if (h3) {
      var innerLink = h3.querySelector('a');
      if (innerLink) {
        var span       = document.createElement('span');
        span.innerHTML = innerLink.innerHTML;
        span.className = innerLink.className;
        h3.innerHTML   = '';
        h3.appendChild(span);
      }
      a.appendChild(h3);
    }
  });
}


// ============================================
// ADA FIX: Empire quickshop modal
//
// Empire's quickshop opens a modal but does not:
//   1. Trap focus inside it (Tab escapes to page)
//   2. Close on Escape
//   3. Return focus to the triggering card on close
// ============================================
function fixQuickshop() {
  var MODAL_SEL     = '.modal--quickshop, .quickshop-modal, [data-modal="quickshop"], .modal__inner';
  var CLOSE_BTN_SEL = '.modal__close, .quickshop__close, [data-modal-close], .remodal-close, button[class*="close"]';
  var TRIGGER_SEL   = '.quickshop-trigger, [data-quickshop-trigger], button[class*="quickshop"], a[class*="quickshop"], .product-item__quickshop button, .grid-item__quickshop button';
  var FOCUSABLE_SEL = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var lastTrigger = null;
  var trapActive  = false;

  // Remember which product card button opened the modal
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(TRIGGER_SEL);
    if (trigger) lastTrigger = trigger;
  }, true);

  // Escape + Tab trap
  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector(MODAL_SEL);
    if (!modal || !isModalVisible(modal)) { trapActive = false; return; }
    trapActive = true;

    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closeModal(modal);
      return;
    }

    if (e.key === 'Tab') {
      var focusable = Array.from(modal.querySelectorAll(FOCUSABLE_SEL)).filter(function (el) {
        return el.offsetParent !== null || window.getComputedStyle(el).position === 'fixed';
      });
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      }
    }
  });

  // Move focus into modal when it opens
  var observer = new MutationObserver(function () {
    var modal = document.querySelector(MODAL_SEL);
    if (modal && isModalVisible(modal) && !trapActive) {
      trapActive = true;
      setTimeout(function () {
        var closeBtn = modal.querySelector(CLOSE_BTN_SEL);
        var first = closeBtn || modal.querySelectorAll(FOCUSABLE_SEL)[0];
        if (first) first.focus();
      }, 100);
    }
  });
  observer.observe(document.body, {
    childList: true, subtree: true,
    attributes: true, attributeFilter: ['class', 'style', 'aria-hidden']
  });

  function isModalVisible(modal) {
    if (!modal) return false;
    var s = window.getComputedStyle(modal);
    if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
    if (modal.getAttribute('aria-hidden') === 'true') return false;
    if (modal.classList.contains('is-hidden') || modal.classList.contains('modal--closed')) return false;
    return true;
  }

  function closeModal(modal) {
    trapActive = false;
    var closeBtn = modal.querySelector(CLOSE_BTN_SEL);
    if (closeBtn) {
      closeBtn.click();
    } else {
      // Fallback: dispatch Escape so Empire's own handler fires
      modal.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    }
    setTimeout(function () {
      if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus();
    }, 150);
  }
}


// ============================================
// ADA FIX: PageFly FAQ accordion
//
// ⚠️ Only targets known FAQ/accordion button
// patterns — NOT all .__pf buttons.
// Using '.__pf button' was breaking focus ring
// detection on all PageFly pages.
// ============================================
function fixPageFlyFAQ() {
  var faqButtons = document.querySelectorAll('button.pf-anchor');

  if (!faqButtons.length) {
    faqButtons = document.querySelectorAll(
      '.__pf .pf-accordion button, .__pf .pf-faq button, .__pf [class*="accordion"] button, .__pf [class*="faq"] button'
    );
  }

  faqButtons.forEach(function (btn) {
    if (btn.classList.contains('navmenu-button')) return;
    if (btn.dataset.adaFixed === 'true') return;
    if (btn.dataset.adaNavFixed === 'true') return;
    btn.dataset.adaFixed = 'true';

    if (!btn.getAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      setTimeout(function () {
        var panel = btn.nextElementSibling || btn.parentElement.nextElementSibling;
        if (!panel || !panel.offsetHeight) {
          var p = btn.closest('[class*="pf-"]');
          if (p) panel = p.nextElementSibling;
        }
        if (panel) {
          btn.setAttribute(
            'aria-expanded',
            window.getComputedStyle(panel).display !== 'none' && panel.offsetHeight > 0
              ? 'true'
              : 'false'
          );
        }
      }, 200);
    });

    // ⚠️ Only preventDefault on Enter/Space — NEVER on Tab
    // Preventing Tab would break focus ring detection
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  });
}


// ============================================
// ADA FIX: Links and labels
// ============================================
function fixAnnouncementBarLink() {
  document.querySelectorAll('a.announcement-bar-link').forEach(function (link) {
    if (!link.getAttribute('aria-label') && !link.textContent.trim()) {
      link.setAttribute('aria-label', 'View current promotion');
    }
  });
}

function fixFooterShopifyLink() {
  document.querySelectorAll('.site-footer-credits a[href*="shopify.com"]').forEach(function (link) {
    if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Powered by Shopify');
  });
}

function fixShopFullCollectionLinks() {
  document.querySelectorAll('a[data-pf-type="Button2"].pf-button-6').forEach(function (link) {
    if (link.dataset.adaLinkFixed === 'true') return;
    link.dataset.adaLinkFixed = 'true';
    var href = link.getAttribute('href') || '';
    var text = link.textContent.trim();
    if (!text) return;
    var match = href.match(/\/collections\/([^?#]+)/);
    if (match) {
      var name = match[1]
        .replace(/-/g, ' ')
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      if (name.toLowerCase() !== text.toLowerCase()) {
        link.setAttribute('aria-label', text + ' — ' + name);
      }
    }
  });
}

function fixDuplicateFooterLinks() {
  var seen = {};
  document.querySelectorAll('a.navmenu-link').forEach(function (link) {
    var href = link.getAttribute('href') || '';
    if (!href) return;
    if (seen[href]) {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    } else {
      seen[href] = true;
    }
  });
}


// ============================================
// ADA FIX: CBB Shipping calculator tab order
// ============================================
function fixCBBShippingTabOrder() {
  var calculator = document.querySelector('.cbb-shipping-rates-calculator');
  if (!calculator || calculator.dataset.wmReordered === 'true') return;
  var addressSection = document.querySelector(
    '.cbb-shipping-rates-calculator-shipping-address-chooser'
  );
  var chooser = document.querySelector('.cbb-shipping-rates-calculator-chooser');
  var header  = document.querySelector('.cbb-shipping-rates-calculator-header');
  if (!addressSection || !chooser) return;
  if (header) header.insertAdjacentElement('afterend', addressSection);
  else calculator.insertBefore(addressSection, calculator.firstChild);
  var map      = chooser.querySelector('.cbb-shipping-rates-calculator-map');
  var rateList = chooser.querySelector('.cbb-shipping-rates-rate-list');
  if (rateList) chooser.insertBefore(rateList, chooser.firstChild);
  if (map) chooser.appendChild(map);
  calculator.dataset.wmReordered = 'true';
}

var cbbObserver = new MutationObserver(function () {
  var calc = document.querySelector('.cbb-shipping-rates-calculator');
  if (calc && calc.dataset.wmReordered !== 'true') {
    if (document.querySelector('.cbb-shipping-rates-calculator-shipping-address-chooser')) {
      setTimeout(fixCBBShippingTabOrder, 300);
    }
  }
});


// ============================================
// ADA FIX: Link-Buttons
//
// Shopify and PageFly output buttons as <a> tags
// styled to look like buttons. Screen readers
// correctly call them "links" and Space bar does
// not activate them (only Enter does on links).
//
// This fix:
//   1. Adds role="button" so screen readers
//      announce them as buttons
//   2. Adds Space key support to activate them
//   3. Skips same-page anchors (#) which should
//      remain links
//   4. MutationObserver covers dynamically loaded
//      PageFly content
// ============================================
function fixLinkButtons() {
  document.querySelectorAll(
    'a[class*="btn"], a[class*="button"], a.button, a.btn, ' +
    '.__pf a[class*="btn"], .__pf a[class*="button"], ' +
    'a[data-pf-type="Button"], ' +
    'a.atc-button, a.site-header-cart--button'
  ).forEach(function (el) {
    if (el.dataset.adaLinkButtonFixed) return;
    el.dataset.adaLinkButtonFixed = 'true';

    var href = el.getAttribute('href') || '';
    if (!href.startsWith('#')) {
      el.setAttribute('role', 'button');
    }

    // Space key support — links only respond to Enter by default
    el.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        el.click();
      }
    });
  });
}

var linkButtonObserver = new MutationObserver(function (mutations) {
  var relevant = mutations.some(function (m) { return m.addedNodes.length > 0; });
  if (relevant) fixLinkButtons();
});


// ============================================
// ADA FIX: Product detail page price focus
//
// Price, discount and title on the product
// detail page are static elements — Tab skips
// them entirely. This fix creates a visually
// hidden but focusable summary element that
// announces the full product info in one clean
// screen reader announcement.
// ============================================
function fixProductDetailPrice() {
  if (!document.querySelector('.product-block--price')) return;

  var existing = document.getElementById('ada-product-summary');
  if (existing) existing.parentNode.removeChild(existing);

  var titleEl = document.querySelector('h1');
  var title = titleEl ? titleEl.textContent.trim() : '';

  var priceEl = document.querySelector('.product-block--price [data-price-container]');
  var price = priceEl ? priceEl.getAttribute('aria-label') || '' : '';
  if (!price && priceEl) {
    var single = priceEl.querySelector('[data-price]');
    if (single) price = 'Price ' + single.textContent.trim();
  }
  // ADA-FIX-START: Add was price + remove unreliable badge reading.
  var compareEl = document.querySelector('.product-block--price [data-compare-price], .product-block--price .price--compare');
  if (compareEl) {
    var compareText = compareEl.textContent.trim();
    if (compareText && price) price = price + ', was ' + compareText;
  }
  var badge = '';
  // ADA-FIX-END

  if (!title && !price) return;

  var priceBlock = document.querySelector('.product-block--price');
  if (!priceBlock) return;

  var summary = document.createElement('div');
  summary.id = 'ada-product-summary';
  summary.setAttribute('tabindex', '0');
  summary.setAttribute('aria-label', [title, price, badge].filter(Boolean).join(', '));
  summary.style.cssText = 'position:absolute;width:0;height:0;padding:0;margin:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;top:0;left:0;pointer-events:none;';

  summary.addEventListener('focus', function () {
    var h1 = document.querySelector('h1');
    var priceBlock = document.querySelector('.product-block--price');
    if (h1) h1.classList.add('ada-detail-focused');
    if (priceBlock) priceBlock.classList.add('ada-detail-focused');
  });
  summary.addEventListener('blur', function () {
    var h1 = document.querySelector('h1');
    var priceBlock = document.querySelector('.product-block--price');
    if (h1) h1.classList.remove('ada-detail-focused');
    if (priceBlock) priceBlock.classList.remove('ada-detail-focused');
  });

  priceBlock.parentNode.insertBefore(summary, priceBlock);
}


// ============================================
// ADA FIX: Product card title link aria-describedby
//
// Tab lands on the product title link. Price and
// sale badge live in sibling divs that Tab never
// reaches. Using aria-describedby appends a hidden
// span after the link text so screen readers
// announce price + badge reliably without
// overriding the visible link text with aria-label.
// Must run after fixSaleBadge and
// fixProductPriceRange so their aria-labels
// are already set before we read them.
// ============================================
function fixProductCardImageLinks() {
  document.querySelectorAll('.productgrid--item').forEach(function (card) {
    // Target the title link specifically — the image link also has
    // data-product-page-link but has tabindex="-1" so Tab skips it
    var titleLink = card.querySelector('p.productitem--title a');
    if (!titleLink) return;

    // Skip if already fixed
    if (titleLink.dataset.adaDescFixed === 'true') return;
    titleLink.dataset.adaDescFixed = 'true';

    // Price — use aria-label already set by fixProductPriceRange
    var priceEl = card.querySelector('[data-price-container]');
    var price = priceEl ? priceEl.getAttribute('aria-label') || priceEl.textContent.trim() : '';

    // Sale badge — only include if aria-label was set (i.e. discount > 0%)
    var badgeEl = card.querySelector('[data-badge-sales-range]');
    var badge = badgeEl ? badgeEl.getAttribute('aria-label') || '' : '';

    // Always need at least a price to describe
    if (!price) return;

    // Create a visually hidden span with the extra info
    var span = document.createElement('span');
    span.id = 'ada-price-' + Math.random().toString(36).substr(2, 9);
    span.className = 'visually-hidden';
    span.textContent = [price, badge].filter(Boolean).join(', ');
    card.appendChild(span);

    // Point the title link at it — screen reader reads link text THEN this span
    titleLink.setAttribute('aria-describedby', span.id);

    // When title link is focused, add class to whole card so CSS
    // draws a focus ring around the entire product card
    titleLink.addEventListener('focus', function () {
      card.classList.add('ada-card-focused');
    });
    titleLink.addEventListener('blur', function () {
      card.classList.remove('ada-card-focused');
    });
  });
}


// ============================================
// ADA FIX: Sale badge accessibility
//
// Empire splits the sale badge text across
// multiple text nodes and child spans which
// screen readers may not stitch together
// reliably. This adds a clean aria-label to
// the badge container.
// ============================================
function fixSaleBadge() {
  // ADA-FIX-START: Badge hidden from screen readers.
  // Percent value is unreliable across variants — silenced until fixed.
  document.querySelectorAll('[data-badge-sales-range]').forEach(function (badge) {
    badge.setAttribute('aria-hidden', 'true');
  });
  // ADA-FIX-END
}


// ============================================
// ADA FIX: Product price range accessibility
//
// Empire theme splits price ranges into two
// separate <span> elements with a plain " - "
// text node between them. Screen readers may
// skip the separator or read it unclearly.
// This fix adds an aria-label to the container
// so screen readers announce the full range
// in plain english e.g. "Price from $9.98 to $42.98".
// Child elements are hidden from screen readers
// since the container aria-label covers them.
// ============================================
function fixProductPriceRange() {
  document.querySelectorAll('[data-price-container]').forEach(function (container) {
    if (container.dataset.adaPriceFixed === 'true') return;
    container.dataset.adaPriceFixed = 'true';

    var min = container.querySelector('[data-price-min]');
    var max = container.querySelector('[data-price-max]');
    var single = container.querySelector('[data-price]');

    if (min && max) {
      // Collection page: price range e.g. "$9.98 – $42.98"
      var minText = min.textContent.trim();
      var maxText = max.textContent.trim();
      container.setAttribute('aria-label', 'Price from ' + minText + ' to ' + maxText);
      min.setAttribute('aria-hidden', 'true');
      max.setAttribute('aria-hidden', 'true');
    } else if (min) {
      // Single price via data-price-min
      container.setAttribute('aria-label', 'Price ' + min.textContent.trim());
      min.setAttribute('aria-hidden', 'true');
    } else if (single) {
      // Product detail page: single price via data-price e.g. "$10.98"
      container.setAttribute('aria-label', 'Price ' + single.textContent.trim());
      single.setAttribute('aria-hidden', 'true');
    }
  });
}


// ============================================
// ADA FIX: Disclosure listbox arrow key navigation
//
// Screen readers intercept arrow keys in browse
// mode. The only way to pass arrow keys through
// to JS is to move actual focus INTO an element
// with role="option" inside role="listbox" —
// this triggers application mode in the screen
// reader so arrow keys reach the page JS.
//
// This fix covers ALL [data-disclosure-toggle]
// dropdowns sitewide (country, currency, etc).
//
// Behavior:
//   - Open: focus moves to selected/first option
//   - ArrowDown/Up: navigate between options
//   - Home/End: jump to first/last option
//   - Enter/Space: activate focused option
//   - Escape: close and return focus to trigger
//   - aria-expanded: kept in sync with open state
//   - aria-activedescendant: tracks active option
// ============================================
function fixDisclosureListbox() {
  document.querySelectorAll('[data-disclosure-toggle]').forEach(function (btn) {
    if (btn.dataset.adaListboxFixed === 'true') return;
    btn.dataset.adaListboxFixed = 'true';

    var listId = btn.getAttribute('aria-controls');
    var list = listId ? document.getElementById(listId) : null;
    if (!list) return;

    // Ensure list has role=listbox
    if (!list.getAttribute('role')) list.setAttribute('role', 'listbox');

    // Give each option a unique ID and ensure role=option
    var options = Array.from(list.querySelectorAll('[role="option"], li a, li button'));
    options.forEach(function (opt, i) {
      if (!opt.id) opt.id = listId + '-opt-' + i;
      if (!opt.getAttribute('role')) opt.setAttribute('role', 'option');
      opt.setAttribute('tabindex', '-1');
    });

    // Watch for open/close — update aria-expanded and move focus in
    var observer = new MutationObserver(function () {
      var isOpen = window.getComputedStyle(list).display !== 'none'
        && list.getAttribute('hidden') === null
        && !list.classList.contains('is-hidden');

      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen && options.length) {
        var selected = options.find(function (o) {
          return o.getAttribute('aria-selected') === 'true';
        }) || options[0];

        btn.setAttribute('aria-activedescendant', selected.id);

        // Move actual DOM focus into the list — this is what switches
        // the screen reader from browse mode to application mode
        setTimeout(function () { selected.focus(); }, 50);
      } else {
        btn.removeAttribute('aria-activedescendant');
      }
    });

    observer.observe(list, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });

    // Arrow key + Home/End/Escape/Enter handling on the list
    list.addEventListener('keydown', function (e) {
      var opts = Array.from(list.querySelectorAll('[role="option"]'));
      if (!opts.length) return;

      var currentIdx = opts.indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = opts[Math.min(currentIdx + 1, opts.length - 1)];
        next.focus();
        btn.setAttribute('aria-activedescendant', next.id);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = opts[Math.max(currentIdx - 1, 0)];
        prev.focus();
        btn.setAttribute('aria-activedescendant', prev.id);
      } else if (e.key === 'Home') {
        e.preventDefault();
        opts[0].focus();
        btn.setAttribute('aria-activedescendant', opts[0].id);
      } else if (e.key === 'End') {
        e.preventDefault();
        opts[opts.length - 1].focus();
        btn.setAttribute('aria-activedescendant', opts[opts.length - 1].id);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        btn.click();
        btn.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (document.activeElement && document.activeElement !== btn) {
          document.activeElement.click();
        }
      }
    });
  });
}
// ============================================
// ADA FIX: Search flydown keyboard navigation
//
// Uses same pattern as fixDisclosureListbox —
// moves actual DOM focus into role=option items
// inside role=listbox to trigger application
// mode in screen readers so arrow keys work.
// Hook: watches style on .search-flydown for
// --open-height changing (same as currency list
// watches style/class/hidden on its list).
// ============================================
function fixSearchFlydown() {
  var input = document.querySelector('input.live-search-form-field');
  if (!input || input._adaSearchFixed) return;
  var flydown = document.querySelector('.search-flydown');
  if (!flydown) return;

  input._adaSearchFixed = true;

  flydown.setAttribute('role', 'listbox');
  flydown.setAttribute('id', 'search-flydown-grid');
  flydown.setAttribute('aria-label', 'Search suggestions');

  function getOptions() {
    return Array.from(flydown.querySelectorAll(
      '.search-flydown__list-item a, .search-flydown--product, .search-flydown__pages-posts-items a'
    ));
  }

  function setupOptions() {
    // Give results tabindex=0 so Tab reaches them
    getOptions().forEach(function(opt, i) {
      if (!opt.id) opt.id = 'search-option-' + i;
      opt.setAttribute('role', 'option');
      opt.setAttribute('aria-selected', 'false');
      opt.setAttribute('tabindex', '0');
    });

    // Remove the Search button and quicklinks from tab order
    // so Tab goes straight to results, not past them
    flydown.querySelectorAll(
      '.search-flydown__continue, .search-flydown--quicklinks-link'
    ).forEach(function(el) {
      el.setAttribute('tabindex', '-1');
    });
  }

  new MutationObserver(function() {
    setupOptions();
  }).observe(flydown, { childList: true, subtree: true });

  setupOptions();

  // ============================================
  // ADA FIX: Nav summary elements aria-label
  //
  // <summary> tags used as nav dropdowns have no
  // accessible name. Adds aria-label from the
  // visible text content of each summary element.
  // ============================================
  function fixNavSummaryLabels() {
    document.querySelectorAll('summary.navmenu-link-parent').forEach(function (summary) {
      if (summary.dataset.adaSummaryFixed === 'true') return;
      summary.dataset.adaSummaryFixed = 'true';

      // Get visible text, excluding the chevron icon span
      var icon = summary.querySelector('.navmenu-icon');
      var label = '';
      summary.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          label += node.textContent;
        } else if (node !== icon && node.nodeType === Node.ELEMENT_NODE) {
          label += node.textContent;
        }
      });
      label = label.trim();
      if (label) summary.setAttribute('aria-label', label);
    });
  }

  // ADA Fix - 5.26.2026 : DO NOT auto-focus results on open — this breaks typing.
  // Screen readers announce results via aria-activedescendant
  // on the input. Focus only moves to results on ArrowDown.
  new MutationObserver(function() {
    var isOpen = input.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      setTimeout(function() {
        setupOptions();
        var opts = getOptions();
        if (!opts.length) return;
        // Set aria-activedescendant so screen reader announces
        // first result — but DO NOT call first.focus()
        input.setAttribute('aria-activedescendant', opts[0].id);
      }, 100);
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }).observe(flydown, {
    attributes: true,
    attributeFilter: ['style']
  });

  flydown.addEventListener('keydown', function(e) {
    var opts = getOptions();
    if (!opts.length) return;
    var idx = opts.indexOf(document.activeElement);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      var next = opts[Math.min(idx + 1, opts.length - 1)];
      next.focus();
      input.setAttribute('aria-activedescendant', next.id);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (idx <= 0) {
        input.focus();
        input.removeAttribute('aria-activedescendant');
      } else {
        var prev = opts[idx - 1];
        prev.focus();
        input.setAttribute('aria-activedescendant', prev.id);
      }
    } else if (e.key === 'Home') {
      e.preventDefault();
      opts[0].focus();
      input.setAttribute('aria-activedescendant', opts[0].id);
    } else if (e.key === 'End') {
      e.preventDefault();
      opts[opts.length - 1].focus();
      input.setAttribute('aria-activedescendant', opts[opts.length - 1].id);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      input.focus();
      var ls = input.closest('.live-search');
      if (ls) ls.classList.remove('live-search--focused', 'live-search--active');
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (document.activeElement && document.activeElement !== input) {
        document.activeElement.click();
      }
    }
  });

  input.addEventListener('input', function() {
    input.removeAttribute('aria-activedescendant');
  });
}

// ============================================
// Run ALL fixes
// ============================================
document.addEventListener('DOMContentLoaded', function () {

  // Focus ring stylesheet
  injectFocusStyles();
  setTimeout(injectFocusStyles, 1000);
  setTimeout(injectFocusStyles, 3000);

  // PageFly circular image links — wrap in real <a> for keyboard access
  fixPageFlyImageLinks();
  setTimeout(fixPageFlyImageLinks, 1500);
  setTimeout(fixPageFlyImageLinks, 3500);

  // Sale badge — hidden from screen readers (unreliable across variants)
  fixSaleBadge();
  setTimeout(fixSaleBadge, 1500);
  setTimeout(fixSaleBadge, 3500);

  // Product price range — announce min/max clearly to screen readers
  fixProductPriceRange();
  setTimeout(fixProductPriceRange, 1500);
  setTimeout(fixProductPriceRange, 3500);

  // Product detail page price — make price container focusable tab stop
  // Must run after fixProductPriceRange and fixSaleBadge so aria-labels are ready
  setTimeout(fixProductDetailPrice, 3000);
  setTimeout(fixProductDetailPrice, 5000);

  // Product card title link — combine title + price + badge into one aria-label
  // Must run after fixSaleBadge and fixProductPriceRange so aria-labels are ready
  setTimeout(fixProductCardImageLinks, 3000);
  setTimeout(fixProductCardImageLinks, 5000);

  // Disclosure listbox — arrow keys + screen reader application mode
  fixDisclosureListbox();
  setTimeout(fixDisclosureListbox, 1500);
  setTimeout(fixDisclosureListbox, 3500);

  // Search flydown — screen reader arrow key navigation
  fixSearchFlydown();
  setTimeout(fixSearchFlydown, 1500);
  setTimeout(fixSearchFlydown, 3500);

  // Quickshop modal: focus trap + Escape + return focus
  fixQuickshop();

  // CBB shipping
  fixCBBShippingTabOrder();
  setTimeout(fixCBBShippingTabOrder, 1000);
  setTimeout(fixCBBShippingTabOrder, 3000);

  // FAQ — delayed to allow PageFly to render its buttons first
  setTimeout(fixPageFlyFAQ, 2500);
  setTimeout(fixPageFlyFAQ, 4500);

  // Links
  fixAnnouncementBarLink();
  fixFooterShopifyLink();
  setTimeout(fixShopFullCollectionLinks, 1500);
  setTimeout(fixShopFullCollectionLinks, 3000);
  setTimeout(fixDuplicateFooterLinks, 500);

  // Link-buttons: role=button + Space key
  fixLinkButtons();
  setTimeout(fixLinkButtons, 1000);
  setTimeout(fixLinkButtons, 3000);
  linkButtonObserver.observe(document.body, { childList: true, subtree: true });

  // Nav summary aria-labels
  fixNavSummaryLabels();
  setTimeout(fixNavSummaryLabels, 1500);
  setTimeout(fixNavSummaryLabels, 3500);

  // CBB watcher
  var cartShipping = document.getElementById('cart-shipping-keyboard-region');
  if (cartShipping) cbbObserver.observe(cartShipping, { childList: true, subtree: true });

});


// ============================================
// FAQ Toggle and Search
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-item .question').forEach(function (item) {
    item.addEventListener('click', function () {
      var faqItem = item.parentElement;
      var answer  = item.nextElementSibling;
      if (faqItem.classList.contains('open')) {
        faqItem.classList.remove('open');
        answer.style.display = 'none';
        item.setAttribute('aria-expanded', 'false');
      } else {
        faqItem.parentElement.querySelectorAll('.faq-item').forEach(function (fi) {
          fi.classList.remove('open');
          fi.querySelector('.answer').style.display = 'none';
          fi.querySelector('.question').setAttribute('aria-expanded', 'false');
        });
        faqItem.classList.add('open');
        answer.style.display = 'block';
        item.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

function filterFAQ(faqId, inputId) {
  var faqSection = document.getElementById(faqId);
  var input      = document.getElementById(inputId);
  if (!faqSection || !input) { console.error('FAQ section or input not found.'); return; }
  var filter = input.value.toLowerCase();
  faqSection.querySelectorAll('.faq-item').forEach(function (item) {
    item.style.display =
      item.querySelector('.question').textContent.toLowerCase().indexOf(filter) > -1 ? '' : 'none';
  });
}